export default __webpack_public_path__ + "static/media/web.fed13e7a.svg";